import { gql } from '@apollo/client';

// Query to get all NSP Core Info entries
export const NSP_CORE_INFO_LIST = gql`
  query NspCoreInfoList {
    nspCoreInfoList {
      nspCoreInfoId
      entryType
      companyName
      address
      city
      province
      postalCode
      faxNumber
      hstRate
      approverEmail
      energyRiskManagementEmail
      contactName
      contactPhone
      contactFax
      contactEmail
      approverName
      logoUrl
      nspGl
    }
  }
`;

// Query to get a specific NSP Core Info by ID
export const NSP_CORE_INFO = gql`
  query NspCoreInfo($nspCoreInfoId: Int!) {
    nspCoreInfo(nspCoreInfoId: $nspCoreInfoId) {
      nspCoreInfoId
      entryType
      companyName
      address
      city
      province
      postalCode
      faxNumber
      hstRate
      approverEmail
      energyRiskManagementEmail
      contactName
      contactPhone
      contactFax
      contactEmail
      approverName
      logoUrl
      nspGl
    }
  }
`;

// Query to get a specific NSP Core Info by entry type
export const NSP_CORE_INFO_BY_TYPE = gql`
  query NspCoreInfoByType($entryType: String!) {
    nspCoreInfoByType(entryType: $entryType) {
      nspCoreInfoId
      entryType
      companyName
      address
      city
      province
      postalCode
      faxNumber
      hstRate
      approverEmail
      energyRiskManagementEmail
      contactName
      contactPhone
      contactFax
      contactEmail
      approverName
      logoUrl
      nspGl
    }
  }
`;

// Mutation to create new NSP Core Info
export const CREATE_NSP_CORE_INFO = gql`
  mutation CreateNspCoreInfo($input: CreateNspCoreInfoInput!) {
    createNspCoreInfo(input: $input) {
      nspCoreInfoId
      entryType
      companyName
      address
      city
      province
      postalCode
      faxNumber
      hstRate
      approverEmail
      energyRiskManagementEmail
      contactName
      contactPhone
      contactFax
      contactEmail
      approverName
      logoUrl
      nspGl
    }
  }
`;

// Mutation to update NSP Core Info
export const UPDATE_NSP_CORE_INFO = gql`
  mutation UpdateNspCoreInfo($nspCoreInfoId: Int!, $input: UpdateNspCoreInfoInput!) {
    updateNspCoreInfo(nspCoreInfoId: $nspCoreInfoId, input: $input) {
      nspCoreInfoId
      entryType
      companyName
      address
      city
      province
      postalCode
      faxNumber
      hstRate
      approverEmail
      energyRiskManagementEmail
      contactName
      contactPhone
      contactFax
      contactEmail
      approverName
      logoUrl
      nspGl
    }
  }
`;

// Mutation to delete NSP Core Info
export const DELETE_NSP_CORE_INFO = gql`
  mutation DeleteNspCoreInfo($nspCoreInfoId: Int!) {
    deleteNspCoreInfo(nspCoreInfoId: $nspCoreInfoId)
  }
`;
